import React from 'react';
import './Navbar.css';
import logo from '../../assets/logo/logo.png'; 

const Navbar = () => {
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
      <nav className='navbar' id='home'>
        <ul>
          <li><a href="#" onClick={() => scrollToSection('home')} className='selected'>Home</a></li>
          <li><a href="#" onClick={() => scrollToSection('about')}>About</a></li>
          <li><a href="#" onClick={() => scrollToSection('tech')}>Technologies</a></li>
          <li><img src={logo} alt="Logo" className="logo" /></li>
          <li><a href="#" onClick={() => scrollToSection('about')}>Resume</a></li>
          <li><a href="#" onClick={() => scrollToSection('project')}>Project</a></li>
          <li><a href="#" onClick={() => scrollToSection('contact')}>Contact</a></li>
        </ul>
      </nav>
    );
}

export default Navbar;
